module.exports = __webpack_public_path__ + "9404b5d5835801684fc4009f12b67748.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/take_two_interactive_software_2022_chart.png
// module id = 1744
// module chunks = 0